<template>
  <Transition
    name="slide"
    mode="in-out"
    @before-enter="beforeEnter"
    @after-enter="afterEnter"
  >
    <slot />
  </Transition>
</template>

<script>
export default {
  methods: {
    beforeEnter (el) {

    },
    afterEnter (el) {

    },
  },
};
</script>

<style scoped>
  .slide-enter-active {
    transition: all .3s ease;
  }
  .slide-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-enter,
  .slide-leave-to {
    transform: translateX(30px);
    opacity: 0;
  }
</style>
